module.exports = "./img/desktop_logo.89c66fb.png";